import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var ParticlesInteractorBase = /*#__PURE__*/_createClass(function ParticlesInteractorBase(container) {
  _classCallCheck(this, ParticlesInteractorBase);
  this.container = container;
  this.type = 1;
});